export const CouponService = {
  /**
   * Retrieves coupon info from backend
   *
   * @param {string} coupon identifier
   * @param {string} amount value of the product
   * @param {string} productId of the discounted product
   * @param {string} email of the user
   * @returns {Promise<{
   *  coupon: string;
   *  amount: string;
   *  amountOff: number;
   *  discountAmount: number;
   *  discountedAmount: number;
   *  percentOff: number;
   *  pixAmount: number;
   *  pixDiscountedAmount: number;
   * }>}
   */
  async getCoupon (coupon, amount, productId, email) {
    const fetchUrlParams = new URLSearchParams({ amount, product_id: productId, email });
    const couponResponse = await fetch(`/coupon_payments/${coupon}?${fetchUrlParams}`);
    if (!couponResponse.ok) {
      throw new Error(`Failed to get coupon: ${couponResponse.statusText}`);
    }
    const couponData = await couponResponse.json();
    if ("error" in couponData) {
      throw new Error(coupon.error);
    }
    const discountAmount = couponData.discount_amount;
    const discountedAmount = couponData.new_amount;

    return {
      coupon,
      amount,
      amountOff: couponData.amount_off,
      percentOff: couponData.percent_off,
      discountAmount,
      discountedAmount,
      pixAmount: couponData.pix_amount,
      pixDiscountedAmount: couponData.pix_discount_amount
    };
  }
};
